import { IconGift } from 'featherico';
import { Divider, OptionLink } from '../../../components/Dropdown';
import { getActiveReleaseNotes } from '../service';
import styles from './style.m.less';

export function JustLaunchedMenuItems() {
    return (
        <>
            <Divider />
            <OptionLink href="https://www.small-improvements.com/release-notes" openInNewTab>
                <IconGift /> What's New
            </OptionLink>
            {/* FIXME */}
            {/* eslint-disable-next-line react-hooks/purity */}
            {getActiveReleaseNotes(Date.now()).map(releaseNote => (
                <OptionLink key={releaseNote.menuItem} href={releaseNote.href} openInNewTab className={styles.menuItem}>
                    <span className={styles.dotContainer}>
                        <span className={styles.dot} />
                    </span>{' '}
                    {releaseNote.menuItem}
                </OptionLink>
            ))}
        </>
    );
}
